export function linkToClinicalProductManagement(): string {
  return "/clinical-product-management";
}

export function linkToVTM(id = ":id"): string {
  return `${linkToClinicalProductManagement()}/vtm/${id}`;
}

export function linkToVMP(id = ":id"): string {
  return `${linkToClinicalProductManagement()}/vmp/${id}`;
}

export function linkToAddVMP(vtmId = ":id"): string {
  return `${linkToVTM(vtmId)}/add-vmp`;
}

export function linkToAddAMP(vmpId = ":id"): string {
  return `${linkToVMP(vmpId)}/add-amp`;
}

export function linkToEditVTM(vtmId = ":id"): string {
  return `${linkToVTM(vtmId)}/edit`;
}

export function linkToEditVMP(vmpId = ":id"): string {
  return `${linkToVMP(vmpId)}/edit`;
}

// Bulk

function linkToBulkClinicalProductManagement(): string {
  return `${linkToClinicalProductManagement()}/bulk`;
}

export function linkToBulkVtmManagement() {
  return `${linkToBulkClinicalProductManagement()}/vtm`;
}

export function linkToBulkVmpManagement() {
  return `${linkToBulkClinicalProductManagement()}/vmp`;
}

export function linkToBulkAmpManagement() {
  return `${linkToBulkClinicalProductManagement()}/amp`;
}
